/** @typedef {import('../../../shared/ThemeProvider/State').default} Response */

import { useContext } from 'react';
import { ThemeContext } from '../../../shared/ThemeProvider';

/** @returns {Response} */
export default function useTheme() {
	return useContext(ThemeContext);
}
